import React, { useEffect } from 'react';
import { TabScroller } from '../ui/tabs/TabScroller';
import { cn } from '@/lib/utils';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface Tab {
  id: string;
  label: string;
}

interface ProfileTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  pendingCount?: number;
  pendingConnectionsCount?: number;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange, pendingCount = 0, pendingConnectionsCount = 0 }) => {
  const { isTrainer } = useCurrentUser();
  
  const tabs: Tab[] = [
    ...(isTrainer ? [{ id: 'trainer', label: 'Trainer' }] : []),
    { id: 'posts', label: 'Moments' },
    { id: 'network', label: 'Connections' },
    { id: 'clubs', label: 'Clubs' },
    { id: 'ratings', label: 'Ratings' },
  ];

  return (
<TabScroller className="overflow-x-auto no-scrollbar whitespace-nowrap -mx-4 px-4 border-b border-dark-300 touch-pan-x">

      <div className="flex items-center space-x-4 px-4">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "px-4 py-2 -mb-px border-b-2 transition-colors whitespace-nowrap flex-shrink-0",
              activeTab === tab.id
                ? "border-gold-400 text-gold-400"
                : "border-transparent text-dark-800 hover:text-white"
            )}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`${tab.id}-panel`}
          >
            <div className="flex items-center">
              {tab.label}
              {tab.id === 'clubs' && pendingCount > 0 && (
                <span className="ml-1.5 px-1.5 py-0.5 bg-gold-400 text-dark-50 text-xs rounded-full min-w-[18px] flex items-center justify-center">
                  {pendingCount}
                </span>
              )}
              {tab.id === 'network' && pendingConnectionsCount > 0 && (
                <span className="ml-1.5 px-1.5 py-0.5 bg-gold-400 text-dark-50 text-xs rounded-full min-w-[18px] flex items-center justify-center">
                  {pendingConnectionsCount}
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </TabScroller>
  );
};

export default ProfileTabs;